import React, { useState, useEffect } from 'react';
import './Keypad.css';
import RiddleCard from "../RiddleCard/RiddleCard";
import LcdDisplay from '../LcdDisplay/LcdDisplay';

const Keypad = ({ status }) => {
    const connected = status !== null;
    const { current_message, lang, sequence, solved } = status ?? {};

    const [lastSequence, setLastSequence] = useState(null);

    useEffect(() => {
        if (sequence?.length === 3) {
            setLastSequence(sequence);
        }
    }, [sequence]);

    const mainDiv = (
        <div className="keypad-container">
            <div className="status-info">
                <LcdDisplay text={current_message} />
                <div className="info-row">
                    <div className="info-item">
                        <label>Language:</label> <span>{lang}</span>
                    </div>
                </div>
                <div className="info-row">
                    <div className="info-item">
                        <label>Current:</label> <span>{sequence || '—'}</span>
                    </div>
                    <div className="info-item">
                        <label>Last:</label> <span>{lastSequence || '—'}</span>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <RiddleCard 
            title={"Keypad"} 
            allSolved={solved} 
            mainInfo={mainDiv} 
            connected={connected}
            index={0} 
            layout="half-size"
        />
    );
};

export default Keypad;
